import { render, staticRenderFns } from "./Edit-doenca.vue?vue&type=template&id=cbebc968&scoped=true&"
import script from "./Edit-doenca.vue?vue&type=script&lang=js&"
export * from "./Edit-doenca.vue?vue&type=script&lang=js&"
import style0 from "./Edit-doenca.vue?vue&type=style&index=0&id=cbebc968&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbebc968",
  null
  
)

export default component.exports